import {HTHSymbol, HTHSymbolStates, ISymbolData} from "../symbols/HTHSymbol";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHGameConfig} from "../HTHGameConfig";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {HTHXWaysSymbol} from "../symbols/HTHXWaysSymbol";
import {HTHXSplitSymbol} from "../symbols/HTHXSplitSymbol";
import {HTHEnhancerSymbol} from "../symbols/HTHEnhancerSymbol";
import {HTHXNudgeSymbol} from "../symbols/HTHXNudgeSymbol";
import {HTHSafeSymbol} from "../symbols/HTHSafeSymbol";
import {HTHNormalSymbol} from "../symbols/HTHNormalSymbol";
import {HTHScatterSymbol} from "../symbols/HTHScatterSymbol";
import {HTHWildSymbol} from "../symbols/HTHWildSymbol";
import {HTHRemovalSymbol} from "../symbols/HTHRemovalSymbol";
import {LayerSet} from "./LayerSet";
import {HTHBlankSymbol} from "../symbols/HTHBlankSymbol";
import {HTHNoWinSymbol} from "../symbols/HTHNoWinSymbol";
import {HTHMaxWinSymbol} from "../symbols/HTHMaxWinSymbol";
import {HTHEnhancerFrame} from "../view/HTHEnhancerFrame";
import {HTHSound} from "../sound/HTHSound";


export class HTHReelView extends PIXI.Container {
    private readonly DURATION_SYMBOLS_FALL_OUT: number = 0.4;
    private readonly DURATION_SYMBOLS_FALL_IN: number = 0.3;
    private readonly DURATION_SYMBOLS_FALL: number = 0.3;
    private readonly DURATION_SYMBOLS_COLLAPSE_FALL: number = 0.1;
    private readonly DURATION_SYMBOLS_UNBLUR: number = 0.02;
    private readonly DURATION_SYMBOLS_EXPAND: number = 0.2;

    private readonly DURATION_FAST_SYMBOLS_FALL_IN: number = 0.2;
    private readonly DURATION_FAST_SYMBOLS_FALL_OUT: number = 0.4;
    private readonly DURATION_FAST_SYMBOLS_EXPAND: number = 0.2;
    //DURATION_FAST_SYMBOLS_COLLAPSE_FALL cant be 0
    private readonly DURATION_FAST_SYMBOLS_COLLAPSE_FALL: number = 0.05;
    private readonly DURATION_FAST_SYMBOLS_FALL_SPIN: number = 0.12;

    private readonly SYMBOLS_FALL_IN_DELAY_NEAR_WIN: number = 0.3;
    private readonly SYMBOLS_FALL_IN_BLUR_DELAY: number = 0.1;
    private readonly SYMBOLS_FALL_IN_DELAY: number = 0.05;
    private readonly SYMBOLS_FALL_OUT_DELAY: number = 0.08;
    private readonly START_DROP_IN_POSITION: number = -1000;
    private _allOutSymbols: HTHSymbol[] = [];
    private _collapsedReel: HTHSymbol[] = [];
    private _xWaysSymbol: HTHSymbol[] = [];
    private _EBSymbolArray: HTHSymbol[] = [];
    private readonly _reelId: number;
    private _isEnhancerReel: boolean = false;
    private _layers: LayerSet;

    constructor(id: number) {
        super();
        this._scatterWinView = new PIXI.Container();

        this._scatterWinView.name = "scatterWinView" + id;

        this.name = "Reel " + id;
        this._isStacked = false;
        this._reelId = id;

        this.position = HTHGameConfig.reelPositions[id];
        this._scatterWinView.position = HTHGameConfig.reelPositions[id];

        this._xWaysSymbol = [];
        if (this._reelId !== 0 && this._reelId !== 5) {
            this._isEnhancerReel = true;
        }
        this._layers = new LayerSet(`_${this._reelId}`);
        this._layers.normalLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.normalSpecial.position = HTHGameConfig.reelPositions[id];
        this._layers.xWLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.wildLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.xSplitLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.removalSymLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.scatterLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.enhancerBlockLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.enhancerBlockOpenedLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.safeLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.fullWildSymbols.position = HTHGameConfig.reelPositions[id];
        this._layers.winLayer.position = HTHGameConfig.reelPositions[id];
        this._layers.maskedEffectsLayer.position = HTHGameConfig.reelPositions[id];
    }

    private _scatterWinView: PIXI.Container;

    get scatterWinView(): PIXI.Container {
        return this._scatterWinView;
    }

    private _isStacked: boolean = false;

    get isStacked(): boolean {
        return this._isStacked;
    }

    set isStacked(value: boolean) {
        this._isStacked = value;
    }

    get reelLayers(): LayerSet {
        return this._layers;
    }


    get isFastSpin(): boolean {
        const fastSpin: boolean = HTH.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
        return fastSpin;
    }

    get needFillUp(): boolean {
        return (this._allOutSymbols.length < 4);
    }

    get needCollapse(): boolean {
        return (this._collapsedReel.length != this._allOutSymbols.length);
    }

    public removeAvalancheSymbol(symbol: HTHSymbol) {
        if (this && this.parent) {
            this.parent.removeChild(symbol);
        }
        symbol.removeAndDestroy();
    }

    public switchSymbol(sym: HTHSymbol, toSym: string): gsap.core.Timeline {
        let newSyms: HTHSymbol[] = [];
        const newSym: HTHSymbol = this.createSymbol({
            symName: toSym,
            symSize: sym.symSize === 0 ? 1 : sym.symSize,
            id: sym.id,
            reelId: this._reelId,
            spinPosition: 0
        }, HTHSymbolStates.NORMAL, sym.id);
        newSyms.push(newSym);
        newSym.alpha = 0;
        newSym.position.set(0, HTHGameConfig.symbolHeight * newSym.id);

        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.removeAvalancheSymbol(sym);
            this._allOutSymbols.splice(sym.id, 1);
            newSyms.forEach((toBeAddedSym: HTHSymbol) => {
                toBeAddedSym.alpha = 1;
                this._allOutSymbols.splice(sym.id, 0, toBeAddedSym);
            });
            newSyms = [];
        }, 0);

        return tl;
    }

    public removeAllSymbols() {
        while (this._allOutSymbols.length > 0) {
            const symbol = this._allOutSymbols[0];
            if (symbol && symbol.symName !== "EB") {
                this._allOutSymbols.shift();
                this.removeAvalancheSymbol(symbol);
            } else {
                break;
            }
        }
    }

    public initReel(symbols: ISymbolData[]): void {
        let toBeFilledUpWithFullWild: boolean = false;
        let maxLength: number = this._reelId === 0 || this._reelId === 5 ? 4 : 3;
        let xnAlreadyPresent: boolean = false;
        for (let i: number = 0; i < maxLength; i++) {

            if (symbols[i].symName !== "AV" && symbols[i].symName !== "BB") {
                const symbol: HTHSymbol = this.createSymbol(symbols[i], HTHSymbolStates.NORMAL, 0, true);
                symbol.position.set(0, HTHGameConfig.symbolHeight * i);

                // if (!(HTH.model.isRestore)) {
                this._allOutSymbols.push(symbol);
            }
            if (symbols[i].symName === "XN") {
                xnAlreadyPresent = true;
            }
        }
        if (this._reelId !== 0 && this._reelId !== 5) {
            const symbol: HTHSymbol = this.createSymbol({
                symName: "EB",
                symSize: 1,
                id: 3,
                reelId: this._reelId,
                spinPosition: 0
            }, HTHSymbolStates.NORMAL, 0, true);
            symbol.position.set(0, HTHGameConfig.symbolHeight * 3);

            this._allOutSymbols.push(symbol);
        }

        if (toBeFilledUpWithFullWild) {
            for (let j: number = 0; j < 5; j++) {
                const filledSymbol: HTHSymbol = this.createSymbol({
                    symName: "Y",
                    symSize: 1,
                    id: j,
                    reelId: this._reelId,
                    spinPosition: 0
                }, HTHSymbolStates.NORMAL, 0, true);
                this._allOutSymbols.unshift(filledSymbol);
            }
        }
    }

    public initForAS(symbols: ISymbolData[]) {
        let maxLength: number = this._reelId === 0 || this._reelId === 5 ? 4 : 3;

        this._allOutSymbols.forEach((sym: HTHSymbol) => {
            if (sym.symName === "EB") {
                this._EBSymbolArray.push(sym);
            }
        });
        this._allOutSymbols = [];
        for (let i: number = 0; i < maxLength; i++) {
            if (symbols[i].symName !== "AV" && symbols[i].symName !== "BB") {
                const symbol: HTHSymbol = this.createSymbol(symbols[i], HTHSymbolStates.NORMAL, 0, true);
                symbol.position.set(0, HTHGameConfig.symbolHeight * i);
                this._allOutSymbols.push(symbol);
            }
        }

        {
            this._EBSymbolArray.forEach((item: HTHSymbol) => {
                this._allOutSymbols.splice(item.id, 0, item);
                item.symName === "EB" ? item.movetoParticularMaskedLayer(this._layers.enhancerBlockLayer) : item.movetoParticularMaskedLayer(this._layers.normalLayer);
            });
            this._allOutSymbols = this.sortSymbolArray(this._allOutSymbols);
            this._EBSymbolArray = [];
        }

        // this.fakeRevealEnhancerSymbol();
    }

    public createSymbol(symbolData: ISymbolData, state: HTHSymbolStates, stageIndex: number, init: boolean = false): HTHSymbol {
        let symbol: HTHSymbol;

        if (symbolData.symName === "XW") {
            symbol = new HTHXWaysSymbol(symbolData, state);
            this._layers.xWLayer.addChild(symbol);
        } else if (symbolData.symName === "XS") {
            symbol = new HTHXSplitSymbol(symbolData, state);
            this._layers.xSplitLayer.addChild(symbol);
        } else if (symbolData.symName === "XN") {
            symbol = new HTHXNudgeSymbol(symbolData, state);
            this._layers.fullWildSymbols.addChild(symbol);
        } else if (symbolData.symName === "EB") {
            symbol = new HTHEnhancerSymbol(symbolData, state);
            this._layers.enhancerBlockLayer.addChild(symbol);
        } else if (symbolData.symName === "SA") {
            symbol = new HTHSafeSymbol(symbolData, state);
            if (HTH.model.mode.includes("NORMAL")) {
                this._layers.scatterLayer.addChild(symbol);
            } else {
                this._layers.safeLayer.addChild(symbol);
            }
        } else if (symbolData.symName === "SC") {
            symbol = new HTHScatterSymbol(symbolData, state);
            this._layers.scatterLayer.addChild(symbol);
        } else if (symbolData.symName === "W") {
            symbol = new HTHWildSymbol(symbolData, state);
            this._layers.wildLayer.addChild(symbol);
        } else if (symbolData.symName === "RW") {
            symbol = new HTHRemovalSymbol(symbolData, state);
            this._layers.removalSymLayer.addChild(symbol);
        } else if (symbolData.symName === "X") {
            symbol = new HTHNoWinSymbol(symbolData, state);
            this._layers.normalLayer.addChild(symbol);
        } else if (symbolData.symName === "MAX") {
            symbol = new HTHMaxWinSymbol(symbolData, state);
            this._layers.normalLayer.addChild(symbol);
        } else if (symbolData.symName === "BL") {
            symbol = new HTHBlankSymbol(symbolData, HTHSymbolStates.BLANK);
            // this._layers.normalLayer.addChild(symbol);
        } else {
            symbol = new HTHNormalSymbol(symbolData, state);
            this._layers.normalLayer.addChild(symbol);
        }
        return symbol;
    }

    public dropOut(reelDelay: number, isNormalBet: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({delay: reelDelay}),
            fastSpin: boolean = this.isFastSpin,
            subTimelines: gsap.core.Timeline[] = [];
        let counter: number = 0,
            isPosEmpty: boolean[] = [false, false, false, false];
        tl.add(() => {
            HTH.reelArea.ebSpinArea.startSpin(this._reelId);
        }, 0);
        for (let i: number = this._allOutSymbols.length - 1; i >= 0; i--) {
            const symbol: HTHSymbol = this._allOutSymbols[i];
            if (this.checkEnhancerSymbolCondition(symbol, isNormalBet)) {
                if (symbol.symName === "SA") {
                    symbol.movetoParticularMaskedLayer(this._layers.scatterLayer);
                }
                this._allOutSymbols.splice(i, 1);
                isPosEmpty[i] = true;
                const fromY: number = symbol.position.y,
                    symSpinStopDelay: number = (fastSpin ? 0 : this.SYMBOLS_FALL_OUT_DELAY) * (counter),
                    turnToBlurDelay: number = (fastSpin ? 0 : this.SYMBOLS_FALL_OUT_DELAY) * counter,
                    timeline = gsap.timeline({delay: symSpinStopDelay});
                if (symbol.id === 0 && (<HTHSafeSymbol>symbol).revealedSymbol?.symName === "XN") {
                    const sym: HTHXNudgeSymbol = <HTHXNudgeSymbol>((<HTHSafeSymbol>symbol).revealedSymbol);
                    const fromY: number = symbol.position.y;
                    const diff: number = (this._reelId == 0 || this._reelId === 5) ? 225 : 150;
                    timeline.to(sym.position, {
                        duration: this.DURATION_SYMBOLS_FALL_OUT,
                        y: fromY + 1000 + diff * 2,
                        ease: "sine.in"
                    }, 0);
                    timeline.add(() => {
                        sym.destroy();
                    })
                }
                timeline.to(symbol.position, {
                    duration: this.DURATION_SYMBOLS_FALL_OUT,
                    y: fromY - this.START_DROP_IN_POSITION,
                    ease: "sine.in",
                }, 0);

                if ((symbol.symName.includes("M") && symbol.symName !== "MAX") || (symbol.symName.includes("L") && symbol.symName !== "BL")) {
                    timeline.add((<HTHNormalSymbol>symbol).makeBlurFilter(0, 3, 0.02), turnToBlurDelay);
                }
                timeline.add(() => this.removeAvalancheSymbol(symbol));
                subTimelines.push(timeline);
                counter++;
            } else {
                const symSpinStopDelay: number = (fastSpin ? 0 : this.SYMBOLS_FALL_OUT_DELAY) * (counter),
                    timeline = gsap.timeline({delay: symSpinStopDelay});
                if (symbol.symName === "SA") {
                    (<HTHSafeSymbol>symbol).isSafeFilled = false;
                    if (symbol.id === 0 && (<HTHSafeSymbol>symbol).revealedSymbol?.symName === "XN") {
                        const sym: HTHXNudgeSymbol = <HTHXNudgeSymbol>((<HTHSafeSymbol>symbol).revealedSymbol);
                        const fromY: number = symbol.position.y;
                        const diff: number = (this._reelId == 0 || this._reelId === 5) ? 225 : 150;
                        timeline.to(sym.position, {
                            duration: this.DURATION_SYMBOLS_FALL_OUT,
                            y: fromY + 1000 + diff * 2,
                            ease: "sine.in"
                        });
                        timeline.add(() => {
                            sym.destroy();
                        })
                    }
                    if (HTH.model.isFreespin || HTH.model.data.mode.includes("EXTRA_SPIN")) {
                        const miniTl: gsap.core.Timeline = gsap.timeline();
                        if ((<HTHSafeSymbol>symbol).revealedSymbol?.symName === "W") {
                            (<HTHSafeSymbol>symbol).popInSpecialsymbol();
                        }
                        miniTl.add((<HTHSafeSymbol>symbol).symbolAnimChange("close_blank"));
                        miniTl.add(() => {
                            HTHSound.playTrack(HTHSound.SAFE_CLOSE);
                        })
                        timeline.add(miniTl, 0);
                    }
                    let finalPos: number = symbol.id;
                    for (let j: number = symbol.id + 1; j <= 3; j++) {
                        if (isPosEmpty[j]) {
                            finalPos = j;
                            isPosEmpty[symbol.id] = true;
                        }
                    }
                    if (symbol.id !== finalPos) {
                        timeline.to(symbol.position, {
                            duration: (this.DURATION_SYMBOLS_FALL_OUT / (1000)) * (finalPos * HTHGameConfig.symbolHeight),
                            y: finalPos * HTHGameConfig.symbolHeight,
                            ease: "sine.in"
                        });
                        symbol.id = finalPos;
                        isPosEmpty[symbol.id] = false; // To handle the case of 2 SA in a reel and leeding to FS e.g. [["L1,SA","L2","SA","L2"],["L1,L3","L3","L3","L3"],["L1,L4","L4","L4",""],["L5","L5","L5",""],["L5","L5","L5",""],["L5","L5","L5","SA"]]
                    } else {
                        timeline.to(symbol.position, {
                            duration: this.DURATION_SYMBOLS_FALL_OUT,
                        });
                    }
                } else {
                    timeline.to(symbol.position, {
                        duration: this.DURATION_SYMBOLS_FALL_OUT,
                    });
                    if (symbol.symName === "EB") {
                        (<HTHEnhancerSymbol>symbol).emptyRevealContainer();
                    }
                }
                subTimelines.push(timeline);
                counter++;
            }
        }

        tl.add(subTimelines);
        return tl;
    }

    public dropIn(perReelDropdelay: number, hasAnticipation: boolean): gsap.core.Timeline {
        const fastSpin: boolean = this.isFastSpin,
            tl: gsap.core.Timeline = gsap.timeline({delay: perReelDropdelay}),
            reelData: ISymbolData[] = HTH.model.reelsData[this._reelId];
        let isTopMostSymbol: boolean = false,
            maxLength: number = 4,
            isFirstSymbolInReel: boolean = true;
        const subTimelines: gsap.core.Timeline = gsap.timeline();
        this._allOutSymbols.forEach((sym: HTHSymbol) => {
            if (sym.symName === "EB" || sym.symName === "SA") {
                this._EBSymbolArray.push(sym);
            }
        });

        this._allOutSymbols = [];
        this._isStacked = false;

        if (this._reelId === 0 && HTH.model.nearWinReels[0]) {
            tl.add(HTH.reelAnticipation.playAnticipation(0), 0);
        }

        for (let i: number = 0; i < maxLength; i++) {
            if (!this.enhancerTypeSymExists(reelData[i])) {
                const symbol: HTHSymbol = this.createSymbol(reelData[i], HTHSymbolStates.NORMAL, 0);
                //debugger;
                if ((symbol.symName.includes("M") && symbol.symName !== "MAX") || (symbol.symName.includes("L") && symbol.symName !== "BL")) {
                    (<HTHNormalSymbol>symbol).makeBlurFilter(0, 3);
                }
                this._allOutSymbols.push(symbol);
                symbol.position.y = this.START_DROP_IN_POSITION + symbol.id * HTHGameConfig.symbolHeight;
                //stop spin fast if feature buy
                const timeline: gsap.core.Timeline = gsap.timeline();
                const totalSpinDuration: number = fastSpin ? this.DURATION_FAST_SYMBOLS_FALL_SPIN : this.DURATION_SYMBOLS_FALL_IN;
                isTopMostSymbol = i === 0;
                timeline.to(this, {duration: fastSpin ? (this.SYMBOLS_FALL_IN_DELAY / 5) * (4 - i) : this.SYMBOLS_FALL_IN_DELAY * (4 - i)})
                timeline.add([
                    gsap.to(symbol.position, {
                        duration: totalSpinDuration,
                        y: symbol.id * HTHGameConfig.symbolHeight,
                        ease: "power1.in",
                        delay: this.SYMBOLS_FALL_IN_DELAY
                    })
                ]);
                if (isTopMostSymbol) {
                    timeline.add(() => {
                        this.topMostSymbolLandingOnReel()
                    });
                }
                const bouncingTime: number = 0.02 + symbol.id * 0.005;
                timeline.add([() => {
                    if (isFirstSymbolInReel) {
                        HTHSound.playLandingSound(this._reelId);
                        isFirstSymbolInReel = false;
                    }
                    this.playSymbolLanding(symbol, 0.1);
                },
                    this.symbolBounce(bouncingTime, symbol, symbol.id * HTHGameConfig.symbolHeight),
                ]);
                if (symbol.symName === "XN") {
                    if ((<HTHXNudgeSymbol>symbol).isPartOfWin) {
                        timeline.add((HTH.gameViewContainer.shakeEffect(0.2, 50, true, 20)), "<");
                    }
                }
                // console.log(this._reelId,symbol.id,timeline.duration());
                subTimelines.add(timeline, 0);
            }
        }
        tl.add(subTimelines, 0);
        tl.add(HTH.reelArea.ebSpinArea.stopSpin(this._reelId));
        tl.addLabel("allsymbolsIn");

        {
            this._EBSymbolArray.forEach((item: HTHSymbol) => {
                this._allOutSymbols.splice(item.id, 0, item);
                if (item.symName === "EB") {
                    item.movetoParticularMaskedLayer(this._layers.enhancerBlockLayer);

                }
                if (item.symName === "SA") {
                    if (HTH.model.mode.includes("NORMAL")) {
                        item.movetoParticularMaskedLayer(this._layers.scatterLayer);
                    } else {
                        item.movetoParticularMaskedLayer(this._layers.safeLayer);
                    }
                }

            });
            this._allOutSymbols = this.sortSymbolArray(this._allOutSymbols);
            this._EBSymbolArray = [];
        }
        if (!HTH.model.reels[this._reelId].includes("SC") && !HTH.model.reels[this._reelId].includes("SA")) {
            tl.add(HTH.reelAnticipation.playAnticipation(this._reelId + 1), "<");
            // tl.add(this.playScatterAnticipation(hasAnticipation), "<");
        }

        tl.add(() => {
            this.fakeRevealEnhancerSymbol();
        }, "allsymbolsIn");
        tl.add(this.revealSafeSymbols(false, (HTH.reelArea.ebSpinArea.isEnhancerSpinning && this._reelId === 5 && HTH.model.reels[5]?.includes("SA")) ? HTH.reelArea.ebSpinArea.tlTime : 0), "allsymbolsIn");

        // console.log(" totalDur :", tl.totalDuration());
        return tl;
    }

    public fillUp(delay: number, fastSpinOn: boolean, toAnticipate: boolean): gsap.core.Timeline {

        //console.log(this._allOutSymbols);
        // debugger;
        const fastSpin: boolean = fastSpinOn;
        const fillUpTimeline = gsap.timeline({delay: delay});
        let nearwinDelay: number = 0,
            isFirstFillupSymbol: boolean = true;

        if (toAnticipate) {
            nearwinDelay = fastSpin ? 0.35 : 0.9;
            fillUpTimeline.to(this, {duration: nearwinDelay});
            fillUpTimeline.add(HTH.reelAnticipation.playAnticipation(this._reelId), this._reelId === 0 ? 0 : ">");
            fillUpTimeline.add(this.playScatterAnticipation(HTH.model.nearWinReels[this._reelId]));

        }

        let isTopSymbol: boolean = false;
        const subTimelines: gsap.core.Timeline = gsap.timeline(),
            reelsFillUpData: ISymbolData[] = HTH.model.reelsData[this._reelId],
            startIndex: number = (4 - this._allOutSymbols.length - 1);

        for (let i: number = startIndex; i > -1; i--) {
            const symbol: HTHSymbol = this.createSymbol(reelsFillUpData[i], HTHSymbolStates.NORMAL, 0, false);
            if ((symbol.symName.includes("M") && symbol.symName !== "MAX") || (symbol.symName.includes("L") && symbol.symName !== "BL")) {
                (<HTHNormalSymbol>symbol).makeBlurFilter(0, 3);
            }

            symbol.position.y = this.START_DROP_IN_POSITION + (symbol.id - startIndex) * HTHGameConfig.symbolHeight;
            this._allOutSymbols.unshift(symbol);
            const timeline = gsap.timeline({delay: ((fastSpin) ? 0 : (this.SYMBOLS_FALL_IN_DELAY * (startIndex - i)))});
            let symDelay: number = this.SYMBOLS_FALL_IN_DELAY;
            const fallDuration: number = fastSpin ? this.DURATION_FAST_SYMBOLS_FALL_SPIN : this.DURATION_SYMBOLS_FALL_IN;
            isTopSymbol = i === 0;
            timeline.add([
                gsap.to(symbol.position, {
                    duration: fallDuration,
                    y: symbol.id * HTHGameConfig.symbolHeight,
                    ease: "power1.in",
                    delay: symDelay
                })
            ]);
            if (isTopSymbol) {
                timeline.add(() => {
                    this.topMostSymbolLandingOnReel()
                });
            }
            const bouncingTime: number = 0.02 + symbol.id * 0.005;
            timeline.add([() => {
                if (isFirstFillupSymbol) {
                    isFirstFillupSymbol = false;
                    HTHSound.playLandingSound(this._reelId);
                }
            },
                this.playSymbolLanding(symbol, 0.1),

                this.symbolBounce(bouncingTime, symbol, symbol.id * HTHGameConfig.symbolHeight)
            ]);
            if (symbol.symName === "XN") {
                if ((<HTHXNudgeSymbol>symbol).isPartOfWin) {
                    timeline.add((HTH.gameViewContainer.shakeEffect(0.2, 50, true, 20)), "<");
                }
            }
            //console.log("Hi",bouncingTime);
            subTimelines.add(timeline, 0);
        }

        fillUpTimeline.add(subTimelines);
        fillUpTimeline.add(HTH.reelArea.ebSpinArea.stopSpin(this._reelId, true));
        fillUpTimeline.addLabel("reelFilled");


        if (this._isEnhancerReel) {
            let ebSym: HTHSymbol = this.getSymbol(3);
            (<HTHEnhancerSymbol>ebSym).isEnhancerOpen ? ebSym.movetoParticularMaskedLayer(this._layers.enhancerBlockOpenedLayer) : ebSym.movetoParticularMaskedLayer(this._layers.enhancerBlockLayer)

        }
        fillUpTimeline.add(this.revealEnhancerSymbol(this._reelId > 0 && this._reelId < 5 && !HTH.reelArea.ebSpinArea.reelModels[this._reelId - 1].spinning && HTH.reelArea.ebSpinArea.isEnhancerSpinning ? HTH.reelArea.ebSpinArea.tlTime : 0));
        fillUpTimeline.add(this.revealSafeSymbols(), "<");
        if (HTH.model.nearWinReels.lastIndexOf(true) <= this._reelId) {
            fillUpTimeline.add(HTH.reelArea.allReels[5].reelView.stopScatterAnticipation(), "reelFilled");
            fillUpTimeline.add(() => {
                HTH.reelAnticipation.reset();
            }, "reelFilled");
        }

        return fillUpTimeline;
    }

    public calculateCollapseData(): void {
        const symbolsLeft: HTHSymbol[] = ArrayHelper.initArrayWithValues(this._allOutSymbols.length, (j: number) => {
            return this._allOutSymbols[j]
        });
        this._collapsedReel = [];

        for (let i: number = symbolsLeft.length - 1; i >= 0; i--) {
            if (!symbolsLeft[i].isRemoved) {
                this._collapsedReel.unshift(symbolsLeft[i]);
                symbolsLeft.splice(i, 1);
            } else {
                symbolsLeft.splice(i, 1);
            }
        }
        // debugger;
    }

    public collapse(reelDelay: number): gsap.core.Timeline {
        const fastSpin: boolean = this.isFastSpin;
        const collapseTimeline: gsap.core.Timeline = gsap.timeline({delay: fastSpin ? 0 : reelDelay}),
            symNum: number = this._collapsedReel.length,
            subTimelines: gsap.core.Timeline[] = [];
        let timeline: gsap.core.Timeline,
            isFirstSymbol: boolean = true,
            toY: number = 3 * HTHGameConfig.symbolHeight;
        // debugger;
        this._allOutSymbols = [];
        let count: number = 3;
        for (let i: number = symNum - 1; i >= 0; i--) {
            const symbol: HTHSymbol = this._collapsedReel[i];
            if (symbol == null) {
                throw new Error(`AvalancheReelPartAnimator.collapseAnimation, symbol is null!`);
            }
            this._allOutSymbols.unshift(symbol);
            if (!symbol.isRemoved) {
                const duration: number = (toY === symbol.position.y) ? 0 : ((fastSpin ? this.DURATION_FAST_SYMBOLS_COLLAPSE_FALL : this.DURATION_SYMBOLS_COLLAPSE_FALL));
                timeline = gsap.timeline();
                if (duration > 0) {
                    timeline.add([
                        gsap.to(symbol.position, {
                            duration: duration,
                            y: toY,
                            ease: "power2.in"
                        })
                    ]);
                    if (symbol.position.y != toY) {
                        timeline.add([
                            () => {
                                if (isFirstSymbol) {
                                    isFirstSymbol = false;
                                    HTHSound.playLandingSound(this._reelId);
                                }
                            },
                            // this.symbolBounce(symbol, toY, false)
                        ]);
                    }
                }

                symbol.id = count;
                count--;
                subTimelines.push(timeline);
            }
            toY -= HTHGameConfig.symbolHeight;

        }
        collapseTimeline.add(subTimelines);
        this._collapsedReel = [];
        return collapseTimeline;
    }

    public avasplitEffect(): gsap.core.Timeline {
        const waysTl: gsap.core.Timeline = gsap.timeline();
        for (let i: number = 0; i < this._allOutSymbols.length; i++) {
            const sym: HTHSymbol = this._allOutSymbols[i];
            if (sym.avaSplitTarget) {
                const avsTl: gsap.core.Timeline = gsap.timeline();

                sym.avaSplitTarget = false;
                // avsTl.add(sym.shakeEffect());


                if (sym.isNormalSymbol) {
                    sym.symSize += 1;
                    avsTl.add((<HTHNormalSymbol>sym).symbolAnimChange(sym.symSize <= 5 ? `split${sym.symSize}` : "split5"));
                    avsTl.add(() => {
                        (<HTHNormalSymbol>sym).addSymbolMultiplier();
                    }, ">")
                } else {
                    avsTl.add(sym.avasplitFireEffect());
                    if (sym.symName === "W") {
                        sym.symSize += 1;
                        avsTl.add(() => {
                            (<HTHWildSymbol>sym).addSymbolMultiplier()
                        }, 0);
                    } else if (sym.symName === "SA") {
                        if ((<HTHSafeSymbol>sym).safeSymSize === 0) {
                            avsTl.add((<HTHSafeSymbol>sym).showWaysIncrease(2));
                        } else if ((<HTHSafeSymbol>sym).safeSymSize > 0) {
                            avsTl.add((<HTHSafeSymbol>sym).showWaysIncrease(1));
                        }
                    }
                }
                //removed 0.23 the half of fireframes' duration, now it updates in end
                waysTl.add(avsTl, 0);
            }
        }
        return waysTl;
    }

    public fakeRevealEnhancerSymbol(): gsap.core.Timeline {
        let revealTl: gsap.core.Timeline = gsap.timeline();
        if (this._reelId !== 0 && this._reelId !== 5) {
            let enhancerSym: HTHEnhancerSymbol = <HTHEnhancerSymbol>this.getSymbol(3);
            let revealSymName: string = HTH.model.data.enhancerBlocks[this._reelId - 1];
            let revealSymSize: number = 1;
            revealTl.add(enhancerSym.fakeRevealAnotherSymbol(revealSymName, revealSymSize));
        }
        return revealTl;
    }

    public revealEnhancerSymbol(addDelay: number = 0): gsap.core.Timeline {
        const revealTl: gsap.core.Timeline = gsap.timeline();
        // if (HTH.model.gameData.consecutiveAvalanches >= 2) {
        if (HTH.model.gameData.consecutiveAvalanches >= 1) {
            if (this._reelId !== 0 && this._reelId !== 5) {
                let enhancerSym: HTHEnhancerSymbol = <HTHEnhancerSymbol>this.getSymbol(3);
                let revealSymName: string = HTH.model.gameData.reels[this._reelId][3];
                let revealSymSize: number = 1;
                if (enhancerSym.isEnhancerOpen && !enhancerSym.isEBFilled) {
                    revealTl.to(this, {duration: addDelay});
                    revealTl.add(enhancerSym.revealAnotherSymbol(revealSymName, revealSymSize));

                    if (enhancerSym.isEnhancerOpen && !enhancerSym.isEBFilled) {
                        enhancerSym.isEBFilled = true;
                        if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                            revealTl.add(() => {
                                (<HTHEnhancerSymbol>enhancerSym).symbolAnimChange("shutter_up")
                            }, "<");
                        } else {
                            revealTl.add(() => {
                                (<HTHEnhancerSymbol>enhancerSym).symbolAnimChange("shutter_up_blank")
                            }, "<");
                        }
                        if (revealSymName === "MAX") {
                            revealTl.add(() => {
                                HTHSound.playTrack(HTHSound.MAX_WIN_SYMBOL_REVEAL);
                            }, "<");
                        } else {
                            revealTl.add(() => {
                                HTHSound.playTrack(HTHSound.ENHANCER_CELL_DOOR_OPEN);
                            }, "<");
                        }
                    }
                    revealTl.add(enhancerSym.symbolAnimChange("blank"));

                }
            }
            // revealTl.to(this, {duration: 0.05});
        }
        return revealTl;
    }

    public moveSymUpLayer(sym: HTHSymbol) {
        if (sym && sym.parent) {
            sym.parent.removeChild(sym);
        }

        sym.movetoParticularMaskedLayer(this._layers.fullWildSymbols);
        sym.position.set(0, sym.id * HTHGameConfig.symbolHeight);
    }

    public moveSymDownLayer(sym: HTHSymbol, parentId: number, moveToNormal: boolean): void {
        if (sym && sym.parent) {
            sym.parent.removeChild(sym);
            if (moveToNormal) {
                //using moveToNormal flag so that full stacked SA reel adds XN in revealed container of 0th SA.
                sym.position.set(0, parentId * HTHGameConfig.symbolHeight);
                HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.normalLayer.addChild(sym);

            }
        }
    }

    public swapSymbols(swapSym1: HTHSymbol, swapSym2: HTHSymbol) {
        const swapPos1 = swapSym1.id;
        const swapPos2 = swapSym2.id;

        if (swapSym1.symName !== "SA" && swapSym1.symName !== "EB" && swapSym2.symName !== "SA" && swapSym2.symName !== "EB") {
            this._allOutSymbols.splice(swapPos1, 1, swapSym2);
            swapSym2.id = swapPos1;
            this._allOutSymbols.splice(swapPos2, 1, swapSym1);
            swapSym1.id = swapPos2;
        } else if ((swapSym1.symName === "SA" || swapSym1.symName === "EB") && swapSym2.symName !== "SA" && swapSym2.symName !== "EB") {
            const revealedSym = (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos1]).revealedSymbol!;
            (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos1]).revealedSymbol = swapSym2;
            (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos1]).revealedSymbol!.id = swapPos1;
            this._allOutSymbols.splice(swapPos2, 1, revealedSym);
            revealedSym.id = swapPos2;
        } else {
            const revealedSym1 = (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos1]).revealedSymbol!;
            const revealedSym2 = (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos2]).revealedSymbol!;
            // (<HTHSafeSymbol>this._allOutSymbols[swapPos2]).addXNudgeRevealSym(revealedSym1);

            (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos1]).revealedSymbol = revealedSym2;

            (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos1]).revealedSymbol!.id = swapPos1;
            (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos2]).revealedSymbol = revealedSym1;
            (<HTHEnhancerSymbol | HTHSafeSymbol>this._allOutSymbols[swapPos2]).revealedSymbol!.id = swapPos2;
        }
    }

    public restoreEnhancerSymbol(): void {

        const enhancerSym: HTHSymbol = this._allOutSymbols[this._allOutSymbols.length - 1];
        if (!(<HTHEnhancerSymbol>enhancerSym).isEnhancerOpen) {
            (<HTHEnhancerSymbol>enhancerSym).isEnhancerOpen = true;
            // let revealSymbolName: string = HTH.model.initData.reelsAfterCollapse[this._reelId][3];
            let revealSymbolName: string = HTH.model.isRestore ? HTH.model.initData.reels[this._reelId][3] : HTH.model.gameData.reelsAfterAvalanche[this._reelId][3];
            let revealSymbolSize: number = HTH.model.isRestore ? HTH.model.initData.sizes[this._reelId][3] : HTH.model.gameData.sizesAfterAvalanche[this._reelId][3];

            if (revealSymbolName === "XN") {
                if (HTH.model.xNudgePositionPerReel[this._reelId][1] === enhancerSym.id) {
                    revealSymbolName = "XN";
                } else {
                    revealSymbolName = "BL";
                }
            }

            if (revealSymbolName !== "EB" && revealSymbolName !== "BL") {
                if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                    (<HTHEnhancerSymbol>enhancerSym).symbolAnimChange("shutter_up");
                } else {
                    (<HTHEnhancerSymbol>enhancerSym).symbolAnimChange("shutter_up_blank");
                }
                (<HTHEnhancerSymbol>enhancerSym).isEBFilled = true;
                (<HTHEnhancerSymbol>enhancerSym).revealAnotherSymbol(revealSymbolName, revealSymbolSize === 0 ? 1 : revealSymbolSize);
            } else {
                if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                    (<HTHEnhancerSymbol>enhancerSym).symbolAnimChange("shutter_down");
                } else {
                    (<HTHEnhancerSymbol>enhancerSym).symbolAnimChange("shutter_down_blank");
                }
            }
            HTHEnhancerFrame.fireHighlights[this._reelId - 1].visible = true;

            HTH.reelArea.enhancerFrame.assignMasks(this._reelId);

            HTHEnhancerFrame.fireHighlights[this._reelId - 1].playLoop();
            (<HTHEnhancerSymbol>enhancerSym).movetoParticularMaskedLayer(HTH.reelArea.allReels[this._reelId].reelView.reelLayers.enhancerBlockOpenedLayer);
        }
    }

    public changeEnhancerAnimOnRestore(): void {
        const enhancerSym: HTHEnhancerSymbol = <HTHEnhancerSymbol>this._allOutSymbols[this._allOutSymbols.length - 1];
        if (!(<HTHEnhancerSymbol>enhancerSym).isEnhancerOpen) {
            if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                enhancerSym.symbolAnimChange("inactive_one");
            } else {
                enhancerSym.symbolAnimChange("inactive_on_nobg");
            }
        }
    }

    public enhancerBlocksInit(animName: string): void {
        const enhancerSym: HTHEnhancerSymbol = <HTHEnhancerSymbol>(this._allOutSymbols[this._allOutSymbols.length - 1]);
        enhancerSym.fakeRevealAnotherSymbol(HTH.model.data.enhancerBlocks[this._reelId - 1], 1);
        enhancerSym.symbolAnimChange(animName);
    }


    public revealSafeSymbols(isRestore: boolean = false, delay: number = 0): gsap.core.Timeline {
        const saferevealAnim: gsap.core.Timeline = gsap.timeline({delay: delay});
        const symArray: HTHSymbol[] = this.getAllSymbols();
        symArray.forEach((symbol: HTHSymbol, index: number) => {
            if (symbol.symName === "SA") {
                if (HTH.model.mode.includes("FREESPIN")) {
                    const safeRevTl: gsap.core.Timeline = gsap.timeline();
                    // const insideSymName: string = HTH.model.gameData.postSafeArea[this._reelId][symbol.id];

                    // const insideSymName: string = HTH.model.data.reels[this._reelId][symbol.id] !=="SA" ? HTH.model.data.reels[this._reelId][symbol.id] : HTH.model.gameData?.evaluatedReels[this._reelId][symbol.id];
                    let insideSymName: string;
                    if (isRestore) {
                        insideSymName = (HTH.model.data.reels[this._reelId][symbol.id] !== "SA" && HTH.model.data.reels[this._reelId][symbol.id] !== "SC") ? HTH.model.data.reels[this._reelId][symbol.id] : "BL";
                    } else {
                        insideSymName = HTH.model.gameData.postSafeArea[this._reelId][symbol.id];
                    }

                    if (insideSymName === "XN") {
                        if (HTH.model.xNudgePositionPerReel[this._reelId][1] === symbol.id) {
                            insideSymName = "XN";
                        } else {
                            insideSymName = "BL";
                        }
                    }

                    const insideSymSize: number = symbol.symSize;
                    let safeSym: HTHSafeSymbol = <HTHSafeSymbol>this.getSymbol(index);
                    if (!safeSym.isSafeFilled && insideSymName !== "BL") {
                        safeRevTl.add(() => {
                            HTHSound.playTrack(HTHSound.SAFE_OPEN);
                        }, 0.01);
                        safeRevTl.add(safeSym.symbolAnimChange("open_blank"), "<");
                        safeRevTl.add(safeSym.symbolAnimChange("frame"));
                        safeRevTl.add(safeSym.revealAnotherSymbol(insideSymName, insideSymSize));
                        if (insideSymName === "XW" || insideSymName === "RW" || insideSymName === "XS" || insideSymName === "W") {
                            safeRevTl.add(safeSym.popOutSpecialsymbol());
                        }
                        if (!isRestore && insideSymName === "XN") {
                            safeRevTl.add(safeSym.popOutXN());
                        }
                        safeSym.isSafeFilled = true;
                    } else if (insideSymName === "BL") {
                        safeRevTl.add(safeSym.symbolAnimChange("normal"));
                    }
                    saferevealAnim.add(safeRevTl, 0);
                }
            }
        });
        return saferevealAnim;
    }

    public makeBlankSymbolsOnReel(isRestoredCase: boolean, keepId: number): void {
        keepId = isRestoredCase ? 0 : keepId;
        if (!this._isStacked) {
            //  debugger
            this._allOutSymbols.forEach((item: HTHSymbol, index: number) => {
                let blankSym: HTHBlankSymbol = new HTHBlankSymbol({
                    symName: "BL",
                    symSize: 1,
                    id: index,
                    reelId: this._reelId,
                    spinPosition: 0
                }, HTHSymbolStates.BLANK);

                blankSym.visible = false;
                if (item.symName !== "SA" && item.symName !== "BL" && item.symName !== "EB" && item.id !== keepId) {
                    item.removeAndDestroy();
                    this._allOutSymbols.splice(item.id, 1, blankSym);
                }
                if (item.symName === "SA" && item.id !== keepId) {
                    (<HTHSafeSymbol>item).revealedSymbol?.removeAndDestroy();
                    (<HTHSafeSymbol>item).revealedSymbol = blankSym;
                    // if (!HTH.model.isRestore) {
                    //     (<HTHSafeSymbol>item).handleMultiplierVisibility(0);
                    // }
                }
                if (item.symName === "EB" && item.id !== keepId) {
                    if ((<HTHEnhancerSymbol>item).isEnhancerOpen) {
                        (<HTHEnhancerSymbol>item).revealedSymbol?.removeAndDestroy();
                        (<HTHEnhancerSymbol>item).revealedSymbol = blankSym;
                    }
                }
            });
        }
        this._isStacked = true;
    }

    public getSymbol(position: number): HTHSymbol {
        if (position > (this._allOutSymbols.length - 1)) {
            debugger;
        }
        return this._allOutSymbols[position];
    }

    public getAllSymbols(): HTHSymbol[] {
        return this._allOutSymbols;
    }

    public setInteractiveSymbols(bool: boolean): void {
        const mode: string = HTH.model.data.mode;
        const nextMode: string = HTH.model.nextMode;

        // if any of the mode is FS/SFS
        if (mode.indexOf("FREESPIN") > -1 && nextMode.indexOf("FREESPIN") > -1) {
            return;
        }

        for (let ctr: number = 0; ctr < this._allOutSymbols.length; ctr++) {
            let currentSym: HTHSymbol = this._allOutSymbols[ctr];
            if (currentSym.isNormalSymbol || currentSym.isEnhancerSymbol || currentSym.symName === "SA") {
                (<HTHNormalSymbol | HTHEnhancerSymbol | HTHSafeSymbol>currentSym).setInteractive(bool);
            }
        }

    }

    public playScatterAnticipation(hasAnticipation: boolean) {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (hasAnticipation) {
            HTH.reelArea.allReels.forEach((reel) => {
                reel.reelView.getAllSymbols().forEach((sym: HTHSymbol) => {
                    if (sym.symName === "SC") {
                        if (!(<HTHScatterSymbol>sym).isAnticipationPlaying) {
                            tl.add((<HTHScatterSymbol>sym).playSpineAnim("anticipation", false, true, 1));
                        }
                    }
                    if (sym.symName === "SA") {
                        if (!(<HTHSafeSymbol>sym).isAnticipationPlaying) {
                            tl.add((<HTHSafeSymbol>sym).ssSymbolAnimChange("anticipation", false, true, 1));
                        }
                    }
                })
            })
        } else {
            tl.add(() => {
                this.stopScatterAnticipation();
                HTH.reelAnticipation.reset();
            }, 0);
        }

        return tl;
    }

    public stopScatterAnticipation(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        HTH.reelArea.allReels.forEach((reel) => {
            reel.reelView.getAllSymbols().forEach((sym: HTHSymbol) => {
                if (sym.symName === "SC") {
                    tl.add((<HTHScatterSymbol>sym).playSpineAnim("idle", false, false));
                } else if (sym.symName === "SA") {
                    tl.add((<HTHSafeSymbol>sym).ssSymbolAnimChange("idle", false, false));
                }
            })
        })
        return tl;

    }

    private playSymbolLanding(sym: HTHSymbol, animTime: number): gsap.core.Timeline {
        const playLandingTl: gsap.core.Timeline = gsap.timeline();
        if ((sym.symName.includes("M") && sym.symName !== "MAX") || (sym.symName.includes("L"))) {
            playLandingTl.add((<HTHNormalSymbol>sym).makeBlurFilter(0, 0));
        } else {
            if (sym.symName === "SC") {
                // playLandingTl.add((<HTHScatterSymbol>sym).playSpineAnim("landing", true, false));
                if (!HTH.model.isFreespin) {
                    playLandingTl.add(() => {
                        HTHGameConfig.scatterCount++;
                        HTHSound.playTrack(`scatter${HTHGameConfig.scatterCount}`);
                    }, "<");
                    playLandingTl.add(HTH.reelAnticipation.playAnticipation(JSON.parse(JSON.stringify(this._reelId)) + 1));
                    playLandingTl.add(this.playScatterAnticipation(HTH.model.nearWinReels[this._reelId + 1]), "<");
                } else {
                    playLandingTl.add(() => {
                        HTHSound.playTrack(HTHSound.SCATTER_FS);
                    }, "<");
                }
                playLandingTl.add(() => {
                    HTH.gameViewContainer.shakeEffect(0.06, HTHGameConfig.scatterCount * 20, true, 30);
                }, "<");

            }
            if (sym.symName === "RW") {
                playLandingTl.add(() => {
                    HTHSound.playTrack(HTHSound.REMOVAL_LANDING);
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.winLayer);
                }, 0);
                playLandingTl.add((<HTHRemovalSymbol>sym).playSpineAnim("landing").totalDuration(0.4), 0);
                playLandingTl.add(() => {
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.removalSymLayer);
                }, ">");
            }
            if (sym.symName === "XW") {
                playLandingTl.add(() => {
                    HTHSound.playTrack(HTHSound.XWAYS_LANDING);
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.winLayer);
                }, 0);
                playLandingTl.add((<HTHXWaysSymbol>sym).animationChange("land").totalDuration(0.4), 0);
                playLandingTl.add(() => {
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.xWLayer);
                }, ">");
            }
            if (sym.symName === "XS") {
                playLandingTl.add(() => {
                    HTHSound.playTrack(HTHSound.XSPLIT_LANDING);
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.winLayer);
                }, 0);
                playLandingTl.add((<HTHXSplitSymbol>sym).animationChange("landing").totalDuration(0.4), 0);
                playLandingTl.add(() => {
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.xSplitLayer);
                }, ">");
            }
            if (sym.symName === "W") {
                playLandingTl.add((<HTHWildSymbol>sym).playSpineAnim("landing").totalDuration(0.4), 0);
                playLandingTl.add(() => {
                    HTHSound.playTrack(HTHSound.WILD_LANDING);
                }, 0);
            }

            if (!HTH.model.isFreespin && sym.symName === "SA") {
                // playLandingTl.add((<HTHSafeSymbol>sym).ssSymbolAnimChange("landing", true, false));
                playLandingTl.add(() => {
                    HTHGameConfig.scatterCount++;
                    HTHSound.playTrack(`scatter${HTHGameConfig.scatterCount}`);
                    HTHSound.playTrack(HTHSound.SCATTER_SUPER_ADD_ON);
                }, "<");
                playLandingTl.add(HTH.reelAnticipation.playAnticipation(JSON.parse(JSON.stringify(this._reelId)) + 1));
                playLandingTl.add(this.playScatterAnticipation(HTH.model.nearWinReels[this._reelId + 1]), "<");
                playLandingTl.add(() => {
                    HTH.gameViewContainer.shakeEffect(0.06, HTHGameConfig.scatterCount * 20, true, 30);
                }, "<");
                if (HTH.model.isFreespin) {
                    HTHSound.playSFSMusic(HTH.model.safeSymbols);
                }
            }

            if (sym.symName === "XN") {
                playLandingTl.add(() => {
                    HTHSound.playTrack(HTHSound.XN_LANDING);
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.winLayer);
                }, 0);
                playLandingTl.add((<HTHXNudgeSymbol>sym).animationChange("landing").totalDuration(0.4), 0);
                playLandingTl.add(() => {
                    (<HTHXWaysSymbol>sym).movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.fullWildSymbols);
                });
            }

            /* if ((sym.symName.includes("M") && sym.symName !== "MAX") || (sym.symName.includes("L"))) {
                 playLandingTl.add((<HTHNormalSymbol>sym).symbolAnimChange("landing"));
                 playLandingTl.totalDuration(landingTime);
             }*/

            // playLandingTl.totalDuration(animTime);
        }
        return playLandingTl;
    }

    private resetSymbolPositions(): void {

        this._allOutSymbols.forEach((sym: HTHSymbol, i: number) => {
            sym.id = i;
            sym.position.set(0, 0);
        });
    }

    private symbolBounce(bounceDuration: number, symbol: HTHSymbol, toY: number, newSymbol: boolean = true): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(symbol.position, {
            duration: bounceDuration, y: toY - 10,
            ease: "power3.in"
        }, 0).to(symbol.position, {
            duration: bounceDuration,
            y: toY,
            ease: "power3.out"
        }, bounceDuration);

        //console.log("Hi",bounceDuration);
        return tl;
    }


    private topMostSymbolLandingOnReel(): void {
        HTH.reelAnticipation.fadeOut(this._reelId);
    }


    private checkEnhancerSymbolCondition(chkSym: HTHSymbol, normalbet: boolean): boolean {
        let notEnhancerTypeSYmbol: boolean = false;
        if (normalbet) {
            notEnhancerTypeSYmbol = chkSym.symName !== "EB";
        } else {
            notEnhancerTypeSYmbol = chkSym.symName !== "EB" && chkSym.symName !== "SA";
        }
        return notEnhancerTypeSYmbol;
    }

    private sortSymbolArray(toBeSorted: HTHSymbol[]): HTHSymbol[] {
        const sortedSymbols: HTHSymbol[] = [];
        //debugger;
        //Sorting symbols with reel position 1-X (position 0 is top padding position)
        for (let i: number = 0; i < 6; i++) {
            for (let j: number = 0; j < toBeSorted.length; j++) {
                if (toBeSorted[j].id === i) {
                    sortedSymbols.push(toBeSorted[j]);
                    break;
                }
            }
        }
        return sortedSymbols;
    }

    private enhancerTypeSymExists(newSym: ISymbolData): boolean {
        let isExist: boolean;
        //debugger;
        isExist = this._EBSymbolArray.some((checkSym: HTHSymbol) => checkSym.id === newSym.id);
        return isExist;
    }
}